import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import { ArrowLeft } from "lucide-react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTemplateDetail } from "../../hooks";
import { AuditInformation } from "./AuditInformation";
import { QuickActions } from "./QuickActions";
import { ActivityLogTab } from "./Tabs/ActivityLog";
import { TemplateUsageTab } from "./Tabs/BillsTable";
import { TemplateDetailsSection } from "./TemplateDetailSection";
import { TemplateHeader } from "./TemplateHeader";

export const TemplateDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: template } = useTemplateDetail(id);
  const handleBackToTemplates = () => {
    navigate("/bx/bill-setup/billtemplate");
  };

  const tabComponents = {
    "template-usage": {
      label: "Template Usage",
      component: <TemplateUsageTab />,
    },
    "activity-log": {
      label: "Activity Log",
      component: <ActivityLogTab entityId={id} />,
    },
  };

  return (
    <div>
      <div>
        <Button
          onClick={handleBackToTemplates}
          variant="outline"
          className="mb-3"
        >
          <ArrowLeft className="h-4 w-4" />
          <span className="text-sm font-medium">Back to Templates</span>
        </Button>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-6">
            {/* Template Header */}
            <TemplateHeader template={template} />

            {/* Template Details */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <TemplateDetailsSection template={template} />
              <div className="border-t border-gray-200 my-6"></div>
              <AuditInformation template={template} />
            </div>

            {/* Tabs Section */}
          </div>

          {/* Quick Actions Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg border border-gray-200 p-6 sticky top-6">
              <QuickActions />
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <Tabs
            tabComponents={tabComponents}
            defaultValue="template-usage"
            urlMapping={{
              "template-usage": "usage",
              "activity-log": "activity",
            }}
            tabsListClassName="w-full grid grid-cols-2 bg-muted/30 p-1"
            idPrefix="template-detail-tab"
          />
        </div>
      </div>
    </div>
  );
};
